export default {
  INDICA: 'INDICA',
  SATIVA: 'SATIVA',
  HYBRID: 'HYBRID',
  CBD: 'CBD',
  NA: 'NA',
}



// WEBPACK FOOTER //
// ./src/constants/cannabisTypes.js